import { SetupSecurity } from "./SetupSecurity";

export default SetupSecurity;
